import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import { product } from '../../components/apipath';
import SwitchBox from "../../components/switchBox";
import {switchHelper} from "../../modules/helpers";
import HTMLEditor from "../../components/htmleditor";


let htmlMainContent = '';


function Admproduct() {
    const [productlist, setProductlist] = useState([]);
    const [editingProduct, setEditingProduct] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [newProduct, setNewProduct] = useState(null); // 用於保存新行的數據
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { token } = useAuth();
    
    
    

    
    //Read 將後端product所有產品資訊導入
    const fetchData = async () => {
        try {
            setLoading(true); // 開始加載
            const response = await axios.get(`${product}`, {headers:{token: token}});
            setProductlist(response.data.data);
            setLoading(false); // 完成加載
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    //Update 設定編輯狀態
    const startEditing = (product) => {
        htmlMainContent = product.content || '';
        setEditingProduct(product);
        setUpdatedData(product);
    };
    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setUpdatedData({
                product_id: editingProduct.product_id,
                ...updatedData,
                [name]: switchHelper(checked),
            });
        } else {
            setUpdatedData({
                product_id: editingProduct.product_id,
                ...updatedData,
                [name]: value,
            });
        }
    };

    
    const handleNewContentChange = (name, contents) => {
        htmlMainContent = contents;
    };

    //Update 將資訊依照product_id回傳給後端
    const saveChanges = async () => {
        const updated = {
            ...updatedData,
            content: htmlMainContent,
        };
        try {
            await axios.put(`${product}`, updated, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token,
                },
            });
            const updatedProductList = productlist.map((product) =>
                product.product_id === editingProduct.product_id ? updated : product
            );
            setProductlist(updatedProductList);
            setEditingProduct(null);
        } catch (error) {
            console.error('Error updating product:', error);
        }
    };
    

    // Create 點擊新增按鈕時的處理函數
    const handleAddNew = () => {
        htmlMainContent = '';
        setNewProduct({
            name: '',
            parent_id: '',
            price: '',
            content: '',
            exp: '',
            applicable: '',
            status: 1,
        });
    };


    // Create 處理新行輸入的變化
    const handleNewInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setNewProduct({
                ...newProduct,
                [name]: switchHelper(checked),
            });
        } else {
            setNewProduct({
                ...newProduct,
                [name]: value,
            });
        }
    };


    // Create 保存新行
    const handleSaveNew = async () => {
        const newData = {
            ...newProduct,
            content: htmlMainContent,
        };
        try {
            const response = await axios.post(`${product}`, newData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token,
                },
            });
            if (response.data.status === 200) {
                alert('新增成功！');
                newData.product_id = response.data.data[1][0].insertId;
                setProductlist([...productlist, newData]);
                setNewProduct(null);
            } else {
                console.error('Error saving new product:', response.data.msg);
            }
        } catch (error) {
            console.error('Error saving new product:', error);
        }
    };
    
    return (
        <>
        <div className="mt100 container-fluid p-5 mt-5">
        <div className="text-end mt-2">
                <button className="btn btn-success me-2" onClick={handleAddNew}>新增</button>
            </div>
            <div className="mt-2 table-responsive">
                <table className="table table-striped border table-hover">
                    <thead>
                        <tr>
                            <th className="w-10">名稱</th>
                            <th className="w-10">分類</th>
                            <th className="w-10">顯示</th>
                            <th className="w-10">價錢</th>
                            <th className="w-40">內容</th>
                            <th className="w-10">期效</th>
                            <th className="w-10">適用對象</th>
                            <th className="w-10">編輯</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* 渲染新行 */}
                        {newProduct && (
                                <tr>
                                    <td>
                                        <input
                                            className="border border-primary form-control form-control-sm"
                                            type="text"
                                            name="name"
                                            value={newProduct.name}
                                            onChange={handleNewInputChange}
                                            required // 必填
                                        />
                                    </td>
                                    <td>
                                        <select
                                            className="form-select form-select-sm"
                                            name="parent_id"
                                            value={newProduct.parent_id}
                                            onChange={handleNewInputChange}
                                            required // 必填
                                        >
                                            <option value={'0'}>請選擇</option>
                                            <option value={'1'}>CPA</option>
                                            <option value={'2'}>CMA</option>
                                            <option value={'3'}>EA</option>
                                            <option value={'4'}>CPE</option>
                                            <option value={'8'}>CIA</option>
                                            <option value={'5'}>學分班</option>
                                            <option value={'6'}>美稅</option>
                                            <option value={'7'}>舊生</option>
                                        </select>
                                    </td>
                                    <td>
                                        {SwitchBox('status', newProduct.status, handleNewInputChange)}
                                    </td>
                                    <td>
                                        <input
                                            className="border border-primary form-control form-control-sm"
                                            type="number"
                                            name="price"
                                            value={newProduct.price}
                                            onChange={handleNewInputChange}
                                            required // 必填
                                        />
                                    </td>
                                    <td>
                                         {HTMLEditor(htmlMainContent || '', 'content', handleNewContentChange)}
                                    </td>
                                    <td>
                                        <input
                                            className="border border-primary form-control form-control-sm"
                                            type="text"
                                            name="exp"
                                            value={newProduct.exp}
                                            onChange={handleNewInputChange}
                                            required // 必填
                                        />
                                    </td>
                                    <td>
                                        <input
                                            className="border border-primary form-control form-control-sm"
                                            type="text"
                                            name="applicable"
                                            value={newProduct.applicable}
                                            onChange={handleNewInputChange}
                                            required // 必填
                                        />
                                    </td>
                                    
                                    <td>
                                        {/* 保存和取消按鈕 */}
                                        <button
                                            className="btn btn-primary m-1"
                                            onClick={handleSaveNew}
                                        >
                                            保存
                                        </button>
                                        <button
                                            className="btn btn-secondary m-1"
                                            onClick={() => setNewProduct(null)}
                                        >
                                            取消
                                        </button>
                                    </td>
                                </tr>
                            )}
                            {productlist.map((product) => (
                                <tr key={product.product_id}>
                                    <td>
                                        {editingProduct && editingProduct.product_id === product.product_id ? (
                                            <input
                                                className="border border-primary form-control form-control-sm"
                                                type="text"
                                                name="name"
                                                value={updatedData.name}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            product.name
                                        )}
                                    </td>
                                    <td>
                                    {editingProduct && editingProduct.product_id === product.product_id ? (
                                        <select
                                        className="form-select form-select-sm"
                                        name="parent_id"
                                        value={updatedData.parent_id}
                                        onChange={handleInputChange}
                                        required
                                        >
                                        <option value={'0'}>請選擇</option>
                                        <option value={'1'}>CPA</option>
                                        <option value={'2'}>CMA</option>
                                        <option value={'3'}>EA</option>
                                        <option value={'4'}>CPE</option>
                                        <option value={'8'}>CIA</option>
                                        <option value={'5'}>學分班</option>
                                        <option value={'6'}>美稅</option>
                                        <option value={'7'}>舊生</option>
                                        </select>
                                    ) : (
                                        product.parent_id === 1
                                        ? "CPA"
                                        : product.parent_id === 2
                                        ? "CMA"
                                        : product.parent_id === 3
                                        ? "EA"
                                        : product.parent_id === 4
                                        ? "CPE"
                                        : product.parent_id === 5
                                        ? "學分班"
                                        : product.parent_id === 6
                                        ? "美稅"
                                        : product.parent_id === 7
                                        ? "舊生"
                                        : product.parent_id === 8
                                        ? "CIA"
                                        : "請選擇"
                                    )}
                                    </td>
                                    <td>
                                        {editingProduct && editingProduct.product_id === product.product_id ? (
                                            SwitchBox('status', updatedData.status, handleInputChange)
                                        ) : (
                                            product.status === 1 ? "顯示" : "不顯示" 
                                        )}
                                    </td>
                                    <td>
                                        {editingProduct && editingProduct.product_id === product.product_id ? (
                                            <input
                                                className="border border-primary form-control form-control-sm"
                                                type="number"
                                                name="price"
                                                value={updatedData.price}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            product.price
                                        )}
                                    </td>
                                    <td>
                                        {editingProduct && editingProduct.product_id === product.product_id ? (
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text">內容</span>
                                                {HTMLEditor(htmlMainContent || '', 'content', handleNewContentChange)}
                                            </div>
                                        ) : (
                                            <div dangerouslySetInnerHTML={{ __html: product.content }}></div>
                                        )}
                                    </td>
                                    <td>
                                        {editingProduct && editingProduct.product_id === product.product_id ? (
                                            <input
                                                className="border border-primary form-control form-control-sm"
                                                type="text"
                                                name="exp"
                                                value={updatedData.exp}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            product.exp
                                        )}
                                    </td>
                                    <td>
                                        {editingProduct && editingProduct.product_id === product.product_id ? (
                                            <input
                                                className="border border-primary form-control form-control-sm"
                                                type="text"
                                                name="applicable"
                                                value={updatedData.applicable}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            product.applicable
                                        )}
                                    </td>
                                    <td>
                                        {editingProduct && editingProduct.product_id === product.product_id ? (
                                            <>
                                                <button
                                                    className="btn btn-primary m-1"
                                                    onClick={saveChanges}
                                                >
                                                    保存
                                                </button>
                                                <button
                                                    className="btn btn-secondary m-1"
                                                    onClick={() => setEditingProduct(null)}
                                                >
                                                    取消
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                className="btn btn-primary m-1"
                                                onClick={() => startEditing(product)}
                                            >
                                                編輯
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
        </>
    );
}
export default Admproduct;